<template>
    <v-toolbar v-if="value" :elevation="$mobile ? 0 : 1" :dense="$mobile">
        <v-toolbar-title v-if="!$mobile" class="mt-2">
            <div>{{ title(value) }}</div>
            <sup class="ml-4 font-italic">{{ value.description }}</sup>
        </v-toolbar-title>

        <v-btn icon small :class="{ 'ml-8': !$mobile }" @click="$emit('view', 'list')" :color="view === 'list' ? 'notice' : undefined">
            <v-icon>list</v-icon>
        </v-btn>

        <v-btn icon small @click="$emit('view', 'grid')" :color="view === 'grid' ? 'notice' : undefined">
            <v-icon>view_module</v-icon>
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn icon small @click="$emit('edit')">
            <v-icon small>create</v-icon>
        </v-btn>
        <bnft-share-menu small icon :url="`https://${domain}/wishlist/${value.id}`" @copy="copy(`https://${domain}/wishlist/${value.id}`)">
            <v-icon small>share</v-icon>
        </bnft-share-menu>

        <v-spacer></v-spacer>
        
        <v-text-field v-model="search" @input="$emit('search', search)" class="d-flex justify-self-end" hide-details prepend-icon="search" placeholder="Search this list" single-line></v-text-field>
    </v-toolbar>
</template>
<style scoped></style>
<script>
import App from '../App.vue';
import BnftShareMenu from './BnftShareMenu.vue';

export default {
    name: 'BnftWishlistNavigation',
    props: {
        value: Object,
        view: String,
    },
    computed: {
        domain: () => document.domain,
    },
    mixins: App.mixins.filter((mixin) => mixin.name === 'copy'),

    components: {
        BnftShareMenu,
    },
    methods: {
        title: (item) => item?.name || item?.id,
    },
    data: function () {
        return {
            search: '',
        };
    },
    mounted() {},
};
</script>
